import React from 'react';
import {Button, Divider, Input, message, Modal, Select, Table} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";

const { Option } = Select;
const { TextArea } = Input;

const blacklistTypeList = [
    {value: 1, label: 'Registration'}
];

export default class EmailBlacklistList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            confirmLoading: false,
            deleteLoadingId: null,
            showCreateModal: false,
            dataList: [],
            totalCount: 0,
            currentPage: 1,
            pageSize: 10,
            query_params: {
                type: 1
            },
            form_params: {}
        }
    }

    componentDidMount() {
        this.loadListData();
    }

    handleQueryInputChange(event) {
        const target = event.target;
        let query_params = Object.assign({}, this.state.query_params);
        query_params[target.name] = target.value;
        this.setState({query_params: query_params});
    }

    handleQuerySelectChange(name, value) {
        let query_params = Object.assign({}, this.state.query_params);
        query_params[name] = value;
        this.setState({query_params: query_params});
    }

    handleFormInputChange(event) {
        const target = event.target;
        const name = target.name;
        let value = target.value;
        if (name === 'domain') {
            value = value.trim();
        }
        let form_params = Object.assign({}, this.state.form_params);
        form_params[name] = value;
        this.setState({form_params: form_params});
    }

    handleFormSelectChange(name, value) {
        let form_params = Object.assign({}, this.state.form_params);
        form_params[name] = value;
        this.setState({form_params: form_params});
    }

    buildQueryParams(changedParams) {
        let params = Object.assign({}, this.state.query_params);
        params.currentPage = changedParams.currentPage;
        params.pageSize = changedParams.pageSize;
        if (typeof params.type === 'undefined' || params.type === null || params.type === '') {
            delete params.type;
        }
        if (!params.domain || params.domain.trim().length === 0) {
            delete params.domain;
        } else {
            params.domain = params.domain.trim();
        }
        return params;
    }

    loadListData(changedParams) {
        if (!changedParams) {
            changedParams = {
                currentPage: 1,
                pageSize: this.state.pageSize
            };
        }

        this.setState({loading: true});
        return new WebServerRestClient().GET('/admin/email-blacklist', this.buildQueryParams(changedParams))
            .then(response => {
                this.setState({loading: false});
                if (response.code === 200) {
                    const data = response.data || {};
                    this.setState({
                        dataList: data.rows || [],
                        totalCount: data.totalCount || 0,
                        currentPage: changedParams.currentPage,
                        pageSize: data.pageSize || changedParams.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(this.getErrorMessage(response));
                }
            }).catch(err => {
                this.setState({loading: false});
                message.error("Error: " + err.message);
            });
    }

    openCreateModal() {
        this.setState({
            showCreateModal: true,
            form_params: {
                type: 1,
                domain: '',
                remarks: ''
            }
        });
    }

    buildSaveParams(form_params) {
        return {
            type: form_params.type || 1,
            domain: form_params.domain.trim(),
            remarks: form_params.remarks || ''
        };
    }

    createRecord() {
        const form_params = this.state.form_params;
        if (!form_params.domain || form_params.domain.trim().length === 0) {
            message.warn('Domain is empty.');
            return false;
        }

        this.setState({confirmLoading: true});
        return new WebServerRestClient().POST('/admin/email-blacklist', this.buildSaveParams(form_params))
            .then(response => {
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showCreateModal: false});
                    this.loadListData({currentPage: 1, pageSize: this.state.pageSize});
                    message.info('success');
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.warn(this.getErrorMessage(response));
                }
            }).catch(err => {
                this.setState({confirmLoading: false});
                message.error("Error: " + err.message);
            });
    }

    confirmDeleteRecord(record) {
        Modal.confirm({
            title: 'Delete email blacklist rule?',
            content: record.domain,
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => this.deleteRecord(record.emailBlacklistId)
        });
    }

    deleteRecord(emailBlacklistId) {
        this.setState({deleteLoadingId: emailBlacklistId});
        return new WebServerRestClient().DELETE('/admin/email-blacklist/' + emailBlacklistId)
            .then(response => {
                this.setState({deleteLoadingId: null});
                if (response.code === 200) {
                    message.info('Deleted');
                    this.loadListData({
                        currentPage: this.state.currentPage,
                        pageSize: this.state.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.warn(this.getErrorMessage(response));
                }
            }).catch(err => {
                this.setState({deleteLoadingId: null});
                message.error("Error: " + err.message);
            });
    }

    getErrorMessage(response) {
        return response['msg'] || response['message'] || 'Request failed';
    }

    renderSingleLineText(value) {
        const text = value === 0 || value ? String(value) : '';
        return <span title={text} style={{whiteSpace: 'nowrap'}}>{text}</span>;
    }

    renderEllipsisText(value) {
        const text = value === 0 || value ? String(value) : '';
        return (
            <span title={text}
                  style={{
                      display: 'block',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                  }}>
                {text}
            </span>
        );
    }

    formatTimestamp(timestamp) {
        if (!timestamp) {
            return '';
        }

        let timeText = String(timestamp);
        if (!/^\d+$/.test(timeText)) {
            return timeText;
        }

        if (timeText.length > 13) {
            timeText = timeText.substring(0, 13);
        }

        let time = Number(timeText);
        if (isNaN(time)) {
            return String(timestamp);
        }
        if (time < 1000000000000) {
            time *= 1000;
        }
        return CommonUtils.formatDate(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    }

    renderBlacklistType(value) {
        if (value === 1) {
            return this.renderSingleLineText('Registration');
        }
        return this.renderSingleLineText(value);
    }

    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Input name={'domain'} placeholder="Domain"
                           className="search_input_middle"
                           value={this.state.query_params.domain || ''}
                           onChange={this.handleQueryInputChange.bind(this)}/>
                    <Divider type="vertical"/>
                    <Button type="primary" icon="search" className="search_btn" loading={this.state.loading}
                            onClick={() => this.loadListData({currentPage: 1, pageSize: this.state.pageSize})}>
                        Search
                    </Button>
                    <div className="button_group">
                        <Button type="link" icon="file-add" size={"small"}
                                onClick={this.openCreateModal.bind(this)}>Create</Button>
                    </div>
                </div>

                <Table loading={this.state.loading}
                       rowKey={(record) => record.emailBlacklistId || record.domain}
                       columns={[
                           {
                               title: 'ID',
                               dataIndex: 'emailBlacklistId',
                               align: 'center',
                               width: 190,
                               render: (value) => this.renderSingleLineText(value)
                           },
                           {
                               title: 'Type',
                               dataIndex: 'type',
                               align: 'center',
                               width: 120,
                               render: (value) => this.renderBlacklistType(value)
                           },
                           {
                               title: 'Domain',
                               dataIndex: 'domain',
                               align: 'left',
                               width: 220,
                               render: (value) => this.renderEllipsisText(value)
                           },
                           {
                               title: 'CreatedTime',
                               dataIndex: 'createdTime',
                               align: 'center',
                               width: 170,
                               render: (value) => this.renderSingleLineText(this.formatTimestamp(value))
                           },
                           {
                               title: 'Remarks',
                               dataIndex: 'remarks',
                               align: 'left',
                               width: 260,
                               render: (value) => this.renderEllipsisText(value)
                           },
                           {
                               title: 'Action',
                               key: 'action',
                               align: 'center',
                               width: 90,
                               render: (text, record) => (
                                   <span style={{whiteSpace: 'nowrap'}}>
                                       <Button type="link"
                                               style={{height: 'auto', padding: 0, lineHeight: 'inherit'}}
                                               loading={this.state.deleteLoadingId === record.emailBlacklistId}
                                               onClick={() => this.confirmDeleteRecord(record)}>Delete</Button>
                                   </span>
                               ),
                           },
                       ]}
                       dataSource={this.state.dataList}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.totalCount,
                           onChange: (currentPage, pageSize) => {
                               this.loadListData({currentPage, pageSize});
                           },
                           showTotal: ((total) => {
                               return `total of ${total} records`;
                           }),
                           className: "pagination"
                       }}/>

                <Modal
                    title="Create Email Blacklist"
                    keyboard={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={this.state.showCreateModal}
                    onCancel={() => this.setState({showCreateModal: false})}
                    onOk={() => this.createRecord()}
                    confirmLoading={this.state.confirmLoading}
                    okText="Save"
                    cancelText="Cancel">
                    <Select className="width_100"
                            placeholder="select type"
                            value={this.state.form_params.type}
                            onChange={(value) => this.handleFormSelectChange('type', value)}>
                        {blacklistTypeList.map(item => (
                            <Option key={item.value} value={item.value}>{item.label}</Option>
                        ))}
                    </Select>
                    <Input name={'domain'} placeholder={'domain'}
                           className="mt_10 width_100"
                           value={this.state.form_params.domain || ''}
                           onChange={this.handleFormInputChange.bind(this)}/>
                    <TextArea name={'remarks'} rows={4} placeholder={'remarks'}
                              className="mt_10 width_100"
                              value={this.state.form_params.remarks || ''}
                              onChange={this.handleFormInputChange.bind(this)}/>
                </Modal>
            </div>
        )
    }
}
